import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContextWithSelector } from './core.mjs';
import { omitBy, isUndefined } from 'lodash';
export { BlockitRendererContext, BlockitRendererContextProvider, useBlockitRendererContext } from './renderer.mjs';
import { IsMobileProvider } from '../hooks/useIsMobile.mjs';

var MoimCommonContext = createContext({});
var MoimCommonContextProvider = function MoimCommonContextProvider(_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  var currentValues = useContextWithSelector(MoimCommonContext, function (state) {
    return state;
  });
  /**
   * 상위 Provider에서 설정된 Value 들을 재사용한다
   */
  var updated = Object.assign(Object.assign({}, currentValues), omitBy(props, isUndefined));
  return jsx(MoimCommonContext.Provider, {
    value: updated,
    children: jsx(IsMobileProvider, {
      children: children
    })
  });
};
function useMoimCommonContext(selector) {
  return useContextWithSelector(MoimCommonContext, selector);
}

export { MoimCommonContextProvider, createContext, useContextWithSelector, useMoimCommonContext };
